var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "api-layer" }, [
    _c("fieldset", [
      _c("legend", [_vm._v("Room")]),
      _c(
        "div",
        {
          staticClass: "api-box inline",
          class: { inline: !_vm.roomInfo.desc },
        },
        [
          _c("label", { staticClass: "api-title" }, [_vm._v("info")]),
          _vm._v(" roomUrlId:"),
          _c("input", { attrs: { type: "text", name: "roomUrlId" } }),
          _vm._v(" roomId:"),
          _c("input", { attrs: { type: "text", name: "roomId" } }),
          _c("button", { on: { click: _vm.getRoomInfo } }, [_vm._v("OK")]),
          !!_vm.roomInfo.desc
            ? _c("div", [_c("pre", [_vm._v(_vm._s(_vm.roomInfo.desc))])])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }